/* eslint-disable import/no-cycle */
import AwernessSection from './AwernessSection/AwernessSection'
import BeforeAfterSection from './BeforeAfterSection/BeforeAfterSection'
import BlogContent from './BlogContent/BlogContent'
import BlogMedia from './BlogMedia/BlogMedia'
import BlogTips from './BlogTips/BlogTips'
import BrindusaHero from './BrindusaHero/BrindusaHero'
import CategoryContent from './CategoryContent/CategoryContent'
import CategoryListing from './CategoryListing/CategoryListing'
import ContentMediaSection from './ContentMediaSection/ContentMediaSection'
import CtaSection from './CtaSection/CtaSection'
import DoctorsSection from './DoctorsSection/DoctorsSection'
import ExperienceSection from './ExperienceSection/ExperienceSection'
import FaqSection from './FaqSection/FaqSection'
import HeroContainer from './HeroContainer/HeroContainer'
import LatestBlogs from './LatestBlogs/LatestBlogs'
import MapSection from './MapSection/MapSection'
import NewTreatmentIntroSection from './NewTreatmentInto/NewTreatmentIntroSection'
import PricingDetailsSection from './PriceDetailsSection/PriceDetailsSection'
import PricingSection from './PricingSection/PricingSection'
import QualityContentSection from './QualityContentSection/QualityContentSection'
import QuoteSection from './QuoteSection/QuoteSection'
import ReviewsContainer from './ReviewsContainer/ReviewsContainer'
import ReviewsSection from './ReviewsSection/ReviewsSection'
import StepsSection from './StepsSection/StepsSection'
import TreatmentDetails from './TreatmentDetails/TreatmentDetails'
import TreatmentIntroSection from './TreatmentIntroSection/TreatmentIntroSection'
import TreatmentResultSection from './TreatmentResultSection/TreatmentResultSection'
import TreatmentSection from './TreatmentSection/TreatmentSection'
import TreatmentsList from './TreatmentsList/TreatmentsList'
import TrustSection from './TrustSection/TrustSection'

export const Awerness = AwernessSection
export const Hero = HeroContainer
export const TreatmentIntro = TreatmentIntroSection
export const TreatmentDetailsSection = TreatmentDetails
export const StepsContainer = StepsSection
export const BeforeAfterSteps = BeforeAfterSection
export const TreatmentResults = TreatmentResultSection
export const Reviews = ReviewsSection
export const Pricing = PricingSection
export const Faq = FaqSection
export const Trust = TrustSection
export const Cta = CtaSection
export const Quote = QuoteSection
export const Treatment = TreatmentSection
export const Doctors = DoctorsSection
export const Experience = ExperienceSection
export const Map = MapSection
export const ContentMedia = ContentMediaSection
export const PricingDetails = PricingDetailsSection
export const TreatmentsListSection = TreatmentsList
export const BrindusaSection = BrindusaHero
export const QualityContent = QualityContentSection
export const LatestBlogsSection = LatestBlogs
export const CategoryContentSection = CategoryContent
export const CategoryListingSection = CategoryListing
export const BlogContentSection = BlogContent
export const BlogMediaSection = BlogMedia
export const BlogTipsSection = BlogTips
export const ReviewWidget = ReviewsContainer
export const NewtIntro = NewTreatmentIntroSection
